import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, FormattedMessage } from 'react-intl';
import classNames from 'classnames';

import DefaultIntlFormatValues from '../definitions/DefaultIntlFormatValues';


function MagicLinkConfirmationScreen({
    email,
    supportPhone = '1-844-808-3379',
    className,
}) {
    return (
        <div
            className={classNames(className, 'rh-text-align-center')}
            data-name="magicLinkConfirmation"
        >
            <h1 className="rh-title-2xl rh-my-1_5">
                <FormattedMessage
                    {...MESSAGES.MAGIC_LINK_CONFIRMATION_TITLE}
                />
            </h1>

            <p className="rh-text-l">
                <FormattedMessage
                    {...MESSAGES.MAGIC_LINK_CONFIRMATION_EMAIL_SENT}
                    values={{
                        ...DefaultIntlFormatValues,
                        email: (
                            <strong className="weight-bold">
                                {email}
                            </strong>
                        ),
                    }}
                />
            </p>
            <p className="rh-text-l weight-medium">
                <FormattedMessage
                    {...MESSAGES.MAGIC_LINK_CONFIRMATION_PROMPT}
                />
            </p>
            <p className="rh-text-m">
                <FormattedMessage
                    {...MESSAGES.MAGIC_LINK_CONFIRMATION_CAPTION}
                    values={{ supportPhone }}
                />
            </p>
        </div>
    );
}

MagicLinkConfirmationScreen.propTypes = {
    email: PropTypes.string.isRequired,
    supportPhone: PropTypes.string,
    className: PropTypes.string,

    messages: PropTypes.shape({
        MAGIC_LINK_CONFIRMATION_TITLE: PropTypes.shape({
            id: PropTypes.string.isRequired,
            defaultMessage: PropTypes.string,
        }),
        MAGIC_LINK_CONFIRMATION_CAPTION: PropTypes.shape({
            id: PropTypes.string.isRequired,
            defaultMessage: PropTypes.string,
        }),
    }),
};

const MESSAGES = defineMessages({
    MAGIC_LINK_CONFIRMATION_TITLE: {
        id: 'Accounts.MagicLinkConfirmationScreen.Title',
        defaultMessage: 'Check your email for a one-time sign-in link',
    },
    MAGIC_LINK_CONFIRMATION_EMAIL_SENT: {
        id: 'Accounts.MagicLinkConfirmationScreen.EmailSent',
        defaultMessage: 'We have sent an email to: <strong>{email}</strong>',
    },
    MAGIC_LINK_CONFIRMATION_PROMPT: {
        id: 'Accounts.MagicLinkConfirmationScreen.Prompt',
        defaultMessage: 'Follow the link to securely sign in, without a password',
    },
    MAGIC_LINK_CONFIRMATION_CAPTION: {
        id: 'Accounts.MagicLinkConfirmationScreen.Caption',
        defaultMessage: 'If you are experiencing any issues, please call us at {supportPhone}.',
    },
});

export default MagicLinkConfirmationScreen;
